module.exports = __webpack_public_path__ + "src/assets/img/Demansia_psammophis_small.2a33b09e.jpg";